import React, { useEffect, useState } from "react";
import { RiExternalLinkLine } from "react-icons/ri";
import certifications from "../data/certifications";
import "aos/dist/aos.css";
import "../index.css";

export default function Certifications() {
  const [maxWidth, setMaxWidth] = useState(0);

  useEffect(() => {
    // Calculate the maximum width needed for any certification title
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = "bold 1.25rem sans-serif"; // TailwindCSS text-xl and font-bold
    const widths = certifications.map(
      (cert) => context.measureText(cert.title).width
    );
    const maxWidth = Math.max(...widths) + 64; // Adding padding/margin
    setMaxWidth(maxWidth);
  }, []);

  return (
    <>
      <div className="mt-10 mx-4 sm:mx-20 mb-20 relative">
        <h1
          className="text-2xl mt-20"
          data-aos="zoom-in-right"
          data-aos-duration="2000"
          data-aos-easing="ease-in-out"
        >
          Certifications
        </h1>
        <div className="scroll-container mt-6 overflow-x-auto scroll-snap-type-x mandatory">
          <div className="scroll-content flex space-x-4 scroll-snap-type-x mandatory">
            {certifications.map((certification, index) => (
              <div
                key={index}
                className="scroll-item flex-none w-full sm:w-auto scroll-snap-start"
                style={{ width: maxWidth }}
              >
                <div className="bg-gray-800 rounded-lg p-4 shadow-md">
                  <img
                    src={certification.image}
                    alt={certification.title}
                    className="w-full h-40 object-cover mb-4 rounded-lg"
                  />
                  <h2 className="text-xl font-bold mb-2">
                    {certification.title}
                  </h2>
                  <a
                    href={certification.view}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-gray-300 flex items-center"
                  >
                    View certificate <RiExternalLinkLine className="ml-1" />
                  </a>
                </div>
              </div>
            ))}
            {/* Repeat the certifications to create a seamless infinite scroll */}
            {certifications.map((certification, index) => (
              <div
                key={index + certifications.length}
                className="scroll-item flex-none w-full sm:w-auto scroll-snap-start"
                style={{ width: maxWidth }}
              >
                <div className="bg-gray-800 rounded-lg p-4 shadow-md">
                  <img
                    src={certification.image}
                    alt={certification.title}
                    className="w-full h-40 object-cover mb-4 rounded-lg"
                  />
                  <h2 className="text-xl font-bold mb-2">
                    {certification.title}
                  </h2>
                  <a
                    href={certification.view}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-400 hover:text-gray-300 flex items-center"
                  >
                    View certificate <RiExternalLinkLine className="ml-1" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <hr className="border-gray-600 my-20" />
    </>
  );
}
